import smallBusiness from './smallBusiness';
import nonprofit from './nonprofit';
import startup from './startup';
import healthcare from './healthcare';
import education from './education';
import government from './government';
import other from './other';

export const CONTENT = {
  smallBusiness,
  nonprofit,
  startup,
  healthcare,
  education,
  government,
  other,
};

export const ORG_TYPES = [
  { value: 'smallBusiness', label: 'Small Business' },
  { value: 'nonprofit', label: 'Nonprofit' },
  { value: 'startup', label: 'Startup' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'education', label: 'Education (K-12 or Higher Ed)' },
  { value: 'government', label: 'Government (state / local / federal)' },
  { value: 'other', label: 'Other' },
];
